import styles from './styles/TypeIcon.css'

export const TypeIcon = ({ className, type }) => (
  <i className={className + ' ' + styles.typeIcon + ' ' + styles[`typeIcon--${type}`]} />
)

export default (TypeIcon)
